import request from '@/utils/request'
export function getList(params) {
  return request({
    url: '/comments/getList',
    method: 'get',
    params,
  })
}
